import { toast } from 'sonner'

import { Select, SelectContent, SelectItem, SelectTrigger } from '@/components/ui/select'
import { parseError } from '@/lib/errors'
import { cn } from '@/lib/utils'
import {
  LeadTemperature,
  temperatureColors,
  temperatureLabels,
  useUpdateLeadPipelineFields,
} from '@/models/myPipeline'

interface TemperatureChipProps {
  leadId: string
  /** Empty until a rep or the sheet import sets one. */
  temperature: LeadTemperature | ''
}

/** The warm table's temperature cell: a chip that is also the picker. */
export function TemperatureChip({ leadId, temperature }: TemperatureChipProps) {
  const update = useUpdateLeadPipelineFields()

  const onChange = (value: string) => {
    update.mutate(
      { id: leadId, temperature: value as LeadTemperature },
      { onError: (error) => toast.error(parseError(error)) }
    )
  }

  const label = temperature ? temperatureLabels[temperature] : 'Set'
  return (
    <Select value={temperature || undefined} onValueChange={onChange} disabled={update.isPending}>
      <SelectTrigger
        aria-label={temperature ? `Temperature: ${label}` : 'Set temperature'}
        className={cn(
          'h-auto rounded-full border-transparent px-2 py-0.5 text-xs font-medium shadow-none',
          temperature
            ? temperatureColors[temperature]
            : 'text-muted-foreground border-dashed border-current/40'
        )}
      >
        {label}
      </SelectTrigger>
      <SelectContent>
        {Object.values(LeadTemperature).map((value) => (
          <SelectItem key={value} value={value}>
            {temperatureLabels[value]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
